<template>
  <div id="main-pdf">
    <slot />
  </div>
</template>

<script>
export default {
  mounted() {
    const getScreenWidth = window.screen.width
    const screenWidth = 790
    if (getScreenWidth < screenWidth) {
      document.getElementById("main-pdf").style.cssText = "width: 790px; margin: 0 auto; padding-top: 20px; padding-bottom: 20px;"
    } else {
      document.getElementById("main-pdf").style.cssText = "width: 794px; margin: 0 auto; padding-top: 20px; padding-bottom: 20px;"
    }
    if (navigator.userAgent.match(/OS X.*Safari/) && ! navigator.userAgent.match(/Chrome/)) {
      document.getElementById("main-pdf").classList.add('safari-pdf')
    }
  }
};
</script>
